import { IconDictionaryItem } from '@cmp-src/controls';

export const TacticIconsDictionary: Record<string, IconDictionaryItem> = {
  tactic: {
    icons: {
      AccessibilityRestroom: 'Accessibility Restroom',
      Coffee: 'Coffee',
      Data: 'Data',
      Elevator: 'Elevator',
      FemaleRestroom: 'Female Restroom',
      GenderNeutral: 'Gender Neutral',
      Library: 'Library',
      Lobby: 'Lobby',
      Lockers: 'Lockers',
      MaleRestroom: 'Male Restroom',
      Mechanical: 'Mechanical',
      Phone: 'Phone',
      Printer: 'Printer',
      ServerRoom: 'Server Room',
      Stairs: 'Stairs',
      Storage: 'Storage'
    },
    keys: [
      'AccessibilityRestroom',
      'Coffee',
      'Data',
      'Elevator',
      'FemaleRestroom',
      'GenderNeutral',
      'Library',
      'Lobby',
      'Lockers',
      'MaleRestroom',
      'Mechanical',
      'Phone',
      'Printer',
      'ServerRoom',
      'Stairs',
      'Storage'
    ]
  }
};
